export enum UserEventTypes {
  CLEAR_USER_EVENT_INFO = 'clearUserEventInfo',
  COMPLETE_ONBOARDING = 'completeUserOnboarding',
  VIEW_INTRO_PARTS_WARRANTY = 'viewIntroOriginalPartsWarranty',
  VIEW_INTRO_SERVICE_HISTORY = 'viewIntroServiceHistory',
  VIEW_INTRO_RESTAURANT_SERVICE_HISTORY = 'viewIntroRestaurantServiceHistory',
  CREATE_SERVICE_HISTORY_RECORD = 'createServiceHistoryRecord',
  VIEW_WHATS_NEW = 'viewWhatsNew',
}
